module.exports = __webpack_public_path__ + "media/images/ca-f9ef5f6411f26c7cf8030ba43de2e672.svg";